module.exports = __webpack_public_path__ + "static/media/mysql.c34a4cf6.png";